import IExtension from '@src/js/common/ark-extensions';

export interface IVipGuideExtension extends IExtension {
    reportHighlightTitle?: {
        docVipUpgradeLinkTextShow?: (position: string) => void;
        docVipUpgradeLinkTextClick?: (position: string, product: string) => void;
    }
}

export enum GuideType {
    /**
     * 设置会员个性色引导,
     * https://tapd.woa.com/TIM_web/prong/stories/view/1010143861875560731
     */
    setPersonlizedColor = 'setPersonlizedColor',
}

export interface IVipGuideExtensionOptions {
    container?: HTMLDivElement | null;
    guideType: GuideType;
    product: string;
    onSuccess?: (color: string) => void;
    onError?: (error: any) => void;
}
